import { render } from "./Article-data-tab.vue?vue&type=template&id=56c28703&scoped=true"
import script from "./Article-data-tab.vue?vue&type=script&lang=js"
export * from "./Article-data-tab.vue?vue&type=script&lang=js"

import "./Article-data-tab.vue?vue&type=style&index=0&id=56c28703&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c28703"]])

export default __exports__